import React from "react";
import { Link } from "react-router-dom";

const MARK = "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/dj8x3pzd_Screenshot%202026-09-25%20at%2022.04.45.png";

// Wordmark version (uses brand mark image + text). Keeps bundle light vs remote image on every render.
export function Logo({ to = "/", className = "", compact = false }) {
  return (
    <Link to={to} className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img src={MARK} alt="Scholavia" className="h-9 w-9 shrink-0 object-contain" />
      {!compact && (
        <span className="font-display text-xl font-extrabold tracking-tight">
          <span className="text-[#4C1D95]">Schola</span>
          <span className="text-[#8B5CF6]">via</span>
        </span>
      )}
    </Link>
  );
}
